import { QBOCompanyInfo, QBOConnectionInfo } from './qbo';
import { DateTime } from 'luxon';

export namespace QBOParsers {
  export class QBOConnectionInfoJson {
    connectedAt!: string;
    companyInfo!: QBOCompanyInfo;
    issues!: string[];
  }

  export function toQBOConnectionInfo(input: QBOConnectionInfoJson): QBOConnectionInfo {
    return {
      companyInfo: input.companyInfo,
      connectedAt: DateTime.fromISO(input.connectedAt, { setZone: true }),
      issues: input.issues,
    };
  }
}
